import { FiltersState } from '../../models/filters'
import { FiltersActions } from '../actions/filters'

let defaultState: FiltersState = {
    activeFilter: false,
    filtersList: [],
}

export default (state = defaultState, action) => {
    switch (action.type) {
        case FiltersActions.SET_ACTIVE_FILTER:
            return {
                ...state,
                activeFilter: action.value,
            }
        case FiltersActions.SET_FILTERS_LIST:
            return {
                ...state,
                filtersList: [...action.value],
            }
        default:
            return state
    }
}
